"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForgotPasswordPage = exports.ForgotPasswordPageConfig = void 0;
var tslib_1 = require("tslib");
var centered_card_1 = require("../components/centered.card/centered.card");
var forgot_password_1 = require("../modules/user/forgot.password");
var forgot_password_ctrl_1 = require("../modules/user/forgot.password.ctrl");
var page_1 = require("./page");
exports.ForgotPasswordPageConfig = {
    type: 'internal',
    name: page_1.IkePageName.forgotPassword,
    path: '/forgot-password',
    auth: { required: false },
    layout: { nav: false, banner: false }
};
var ForgotPasswordPage = /** @class */ (function (_super) {
    tslib_1.__extends(ForgotPasswordPage, _super);
    function ForgotPasswordPage() {
        var _this = _super.call(this, exports.ForgotPasswordPageConfig) || this;
        var ctrl = new forgot_password_ctrl_1.ForgotPasswordCtrl();
        _this.component = new forgot_password_1.ForgotPasswordComponent(ctrl);
        return _this;
    }
    Object.defineProperty(ForgotPasswordPage.prototype, "nodes", {
        get: function () {
            return centered_card_1.CenteredCard.view(this.component.view());
        },
        enumerable: false,
        configurable: true
    });
    return ForgotPasswordPage;
}(page_1.IkePage));
exports.ForgotPasswordPage = ForgotPasswordPage;
//# sourceMappingURL=forgot.password.page.js.map